import { showPromoAnalysisModal, showRevenueModal } from "@actions/modals";
import collections from "@api/collections";
import revenue from "@api/revenue";
import BaseRevenueView from "@components/revenue/BaseRevenueView";
import { handleDownload } from "@helpers/downloads";
import { connect } from "react-redux";

class RevenueView extends BaseRevenueView {
  useGroupBy = true;
  fnGetViewTypes = revenue.getRevenueViewTypes;
  fnGetGraphOptions = revenue.getRevenueGraphOptions;
  isVariance = false;

  handleApiCall = (fnRequest, fnSuccess, fnFailure) => {
    const {
      selectedOperator,
      selectedCompany,
      selectedSubCompany,
      selectedWeek,
      selectedViewType,
      selectedCategory,
      selectedGroupBy,
      selectedRegion,
    } = this.state;

    fnRequest(
      selectedOperator,
      selectedCompany,
      selectedSubCompany,
      selectedWeek,
      selectedCategory,
      selectedViewType,
      selectedGroupBy,
      selectedRegion,
    ).then(
      (response) => fnSuccess(response),
      () => fnFailure(),
    );
  };

  handleRefresh = () => {
    this.setState({ loading: true }, () => {
      this.handleApiCall(
        revenue.getSummary,
        (summary) => this.setState({ summary, loading: false }),
        () => this.setState({ loading: false }),
      );
    });
  };

  onExportClick = () => {
    this.setState({ exportLoading: true }, () => {
      this.handleApiCall(
        revenue.getRevenueSummaryExport,
        (summary) =>
          this.setState({ exportLoading: false }, () =>
            handleDownload(summary),
          ),
        () => this.setState({ exportLoading: false }),
      );
    });
  };

  onDetailsClick = () => {
    const { selectedViewType, activeRow, selectedOperator } = this.state;
    if (selectedViewType !== 4) {
      this.props.showRevenueModal(
        activeRow,
        selectedOperator,
        this.isVariance,
        () => this.handleRefresh(),
      );
    } else {
      this.setState({ detailsLoading: true }, () => {
        collections
          .getPeriods(selectedOperator, activeRow.siteId)
          .then((periods) => {
            const selectedPeriod = periods[0].value;
            collections
              .getPromoCashDetails(selectedPeriod, activeRow.siteId)
              .then((grid) =>
                this.props
                  .showPromoAnalysisModal(periods, selectedPeriod, grid)
                  .then(() => this.setState({ detailsLoading: false })),
              );
          });
      });
    }
  };

  refreshGraph = () => {
    const {
      selectedOperator,
      selectedCompany,
      selectedSubCompany,
      selectedWeek,
      selectedCategory,
      selectedGroupBy,
      selectedRegion,
      selectedViewType,
      selectedVarianceType,
      activeRow,
    } = this.state;
    this.setState({ chartLoading: true }, () => {
      revenue
        .getGraph(
          selectedOperator,
          selectedCompany,
          selectedSubCompany,
          activeRow.siteId,
          selectedWeek,
          selectedCategory,
          selectedViewType,
          selectedVarianceType,
          selectedGroupBy,
          selectedRegion,
        )
        .then(
          (graph) => this.setState({ graph, chartLoading: false }),
          () => this.setState({ chartLoading: false }),
        );
    });
  };
}
const mapStateToProps = (state, ownProps) => {
  return {
    operators: state.operators.filter((x) => x.value !== -1),
  };
};

export default connect(mapStateToProps, {
  showRevenueModal,
  showPromoAnalysisModal,
})(RevenueView);
